import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import { useMediaQuery } from "react-responsive";

import { useHamburger } from "context/hamburger";

import AnimatedIntersection from "components/AnimatedIntersection";
import { Nav, Clinics, Info, Summary } from "./components";
import clsx from "clsx";

const rows = [<Nav />, <Clinics />, <Info />, <Summary />];

const Footer = ({ bottomPadding }) => {
  const { setIsContactOpen, setIsCompactContactOpen } = useHamburger();

  const isBrowser = typeof window !== "undefined";
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });

  const links = [
    {
      label: "Umów wizytę",
      url: "/rezerwacja-wizyt/",
    },
    {
      label: "Zadzwoń",
      onClick: isBrowser
        ? isMobile
          ? () => setIsCompactContactOpen(true)
          : () => setIsContactOpen(true)
        : undefined,
    },
    {
      label: "Wyślij wiadomość",
      url: "/kontakt/",
    },
  ];

  return (
    <AnimatedIntersection
      id="footer-gradient"
      type="footer"
      className={clsx("footers", !!bottomPadding && "footers--bottom-padding")}
      childrenHeader={
        <>
          <div className="footers__header">
            <h3>Skontaktuj się z nami</h3>
            <ul>
              {links.map((link, index) => {
                const isButton = typeof link?.onClick === "function";
                const isLink = link?.url;
                const Type = isButton ? "button" : isLink ? Link : "div";

                return (
                  <li key={index}>
                    <Type
                      type={isButton ? "button" : undefined}
                      to={isLink ? link.url : undefined}
                      onClick={isButton ? link.onClick : undefined}
                    >
                      {link.label}
                    </Type>
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      }
      options={{ timeProgress: 0.76, seed: 11 }}
      variant="blue-light"
      isContainerless
    >
      {rows.map((row, index) => (
        <div key={index} className="footers__row">
          <div className="container">{row}</div>
        </div>
      ))}
    </AnimatedIntersection>
  );
};

export default Footer;
